import React from 'react';
import PropTypes from 'prop-types';

const FeatureCard = ({ icon, title, description, className = '' }) => {
  return (
    <div
      className={`flex flex-row md:flex-col items-start md:items-center gap-3 flex-1 ${className}`}
    >
      <img src={icon} alt={title} className="w-15 md:w-20 h-15 md:h-20 p-2" />
      <div className="flex flex-col gap-1 text-left md:text-center">
        <h3 className="text-xl leading-[30px] text-gray-90 font-semibold">
          {title}
        </h3>
        <p className="text-sm leading-5 font-normal text-gray-90">
          {description}
        </p>
      </div>
    </div>
  );
};

FeatureCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FeatureCard;
